module.exports = __webpack_public_path__ + "img/瑞金纪念馆.f54a4e96.png";